import includes from 'lodash/includes';
import { useState } from 'react';
import constants from 'src/utils/constants';

type ImageProps = {
	src: string;
	alt?: string;
	width?: any;
	height?: any;
	style?: object;
	imageFit?: string;
	imgClass?: any;
	loadingType?: any;
	onLoading?: any;
	onError?: any;
	fallbackSrc?: string;
	onClick?: any;
	id?: string;
	variation_required?: boolean;
	// timeout?: number;
};

const Image = ({
	src,
	alt,
	style,
	imageFit,
	width,
	height,
	imgClass,
	onLoading,
	onError,
	loadingType,
	onClick,
	fallbackSrc,
	id,
	variation_required = false,
	// timeout,
	...rest
}: ImageProps) => {
	// const [imageSrc, setImageSrc] = useState(src || fallbackSrc || constants.FALLBACK_IMAGE);
	// const [isLoaded, setIsLoaded] = useState(false);

	// useEffect(() => {
	// 	const timer = setTimeout(() => {
	// 		if (!isLoaded) {
	// 			setImageSrc(fallbackSrc || constants.FALLBACK_IMAGE);
	// 		}
	// 	}, timeout); // Use the provided timeout or default to 15 seconds

	// 	return () => clearTimeout(timer); // Cleanup on unmount
	// }, [isLoaded, fallbackSrc, timeout]);

	// useEffect(() => {
	// 	setImageSrc(src || constants.FALLBACK_IMAGE);
	// }, [src]);

	// const handleLoad = () => {
	// 	setIsLoaded(true);
	// };

	const [has_loading_error, set_has_loading_error] = useState(false);

	const handleFallback = (e: React.SyntheticEvent<HTMLImageElement>) => {
		set_has_loading_error(true);
		if (fallbackSrc) {
			e.currentTarget.src = fallbackSrc;
		} else {
			e.currentTarget.src = constants.FALLBACK_IMAGE;
		}
	};

	const autoObjectFit: 'contain' | 'cover' = includes(src, 'store_front_img_not_found.svg') || has_loading_error ? 'cover' : 'contain';

	let controlled_style: any = {
		objectFit: imageFit || autoObjectFit,
	};

	if (variation_required && has_loading_error) {
		controlled_style.height = 'auto';
	}

	controlled_style = {
		...controlled_style,
		...style,
	};

	return (
		<img
			// src={imageSrc}
			src={src}
			alt={alt}
			onClick={onClick}
			id={id}
			style={controlled_style}
			className={imgClass}
			loading={loadingType}
			width={width}
			onLoad={onLoading}
			onError={onError ?? handleFallback}
			height={variation_required && has_loading_error ? null : height}
			{...rest}
		/>
	);
};

Image.defaultProps = {
	src: '',
	alt: '',
	width: 20,
	height: 20,
	style: {},
	imgClass: {},
	loadingType: 'lazy',
	fallbackSrc: constants.FALLBACK_IMAGE,
	onLoading: () => {},
	onError: null,
	onClick: null,
	id: '',
	variation_required: false,
	// timeout: constants.DEFAULT_IMAGE_TIMEOUT,
};

export default Image;
